const partnerFilter = window.location.href.substr(
  window.location.href.lastIndexOf("?") + 1
);

const apirPartners = "/rest/apl-web-site-institucional/v1/parceiros";
// const apirPartners = "http://localhost:56823/apl-web-site-institucional/v1/parceiros";

const objQueryParam = {
  fgts: "lojista=false&correspondente=true&fgts=true",
  consignado: "lojista=false&correspondente=true",
  solar: "Correspondente=false&Lojista=false&Fgts=false&Solar=true",
};

const corbanCorrespondent = {
  nameControl: "",
  searchType: "nome",
  search: "",
  address: "",
  input: document.querySelector("input.js-corban-correspondent-input"),
  correspondentContainer: document.querySelector(".js-corban-correspondent"),
  btnFindMore: document.querySelector("button.js-btn-find-more"),
  titleResult: document.querySelector(".js-title-result"),
  msgResult: document.querySelector(".js-msg-result"),
  loading: document.querySelector(".js-loading"),
  resultContainer: document.querySelector(".js-result-container"),
  msgValidationField: document.getElementById("msgValidationField"),
  formFindCorrespondent: document.querySelector(
    ".js-corban-correspondent-form"
  ),
  btnSearch: document.querySelector(".js-corban-correspondent-search"),
  resetForm: document.querySelector(".js-btn-reset-form"),
  numberPage: 0,

  init() {
    this.initialConfig();
    this.searchInput();
    this.toggleSearchType();
    this.resetResult(), this.clearForm();
  },

  initialConfig() {
    this.correspondentContainer.innerHTML = "";
    this.numberPage = 0;
    this.btnSearch.disabled = true;
    this.msgValidationField.textContent = "";
    this.msgValidationField.style.visibility = "hidden";
    this.btnFindMore.style.visibility = "hidden";
    this.btnFindMore.textContent = "Carregar mais";
    this.titleResult.style.display = "block";
    this.msgResult.style.display = "block";
    this.msgResult.textContent =
      "Para encontrar o melhor parceiro, preencha um dos campos de busca.";

      const input = document.querySelector(".js-corban-correspondent-input");
      input.classList.add("corban-correspondent__input--show-placeholder");
      input.placeholder = "Pesquise por Nome ou Razão Social";
      this.nameControl = "nome";
  },

  incrementPage() {
    this.numberPage += 10;
    return this.numberPage;
  },

  async renderCorrespondent() {
    this.loading.style.display = "flex";
    this.btnFindMore.style.visibility = "hidden";
    this.titleResult.style.display = "none";
    this.msgResult.style.display = "none";

    // const input = document.querySelector(".js-corban-correspondent-input");
    // input.classList.add("corban-correspondent__input--show-placeholder");
    // input.placeholder = "Pesquise por Nome ou Razão Social";

    return fetch(
      `${apirPartners}?${objQueryParam[partnerFilter]}&paginacao=${this.numberPage}${this.search}`
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && result.data && result.data.length > 0) {
          const listData = result.data;
          this.address = listData[0]?.enderecoMaps || listData[0]?.endereco;

          listData.forEach((element, index) => {
            const resultDiv = document.createElement("li");
            resultDiv.innerHTML = `<span><strong>${
              element.nomeFantasia
            }</strong></span> ${
              partnerFilter === "solar"
                ? ""
                : `<span>${element.razaoSocial}</span>`
            }  <span>${element.endereco}</span><span>${
              element.telefone
            }</span>`;
            resultDiv.classList.add("corban-correspondent__list-item");
            document
              .querySelector(".corban-correspondent__list")
              .appendChild(resultDiv);
          });

          const totalReg = document.querySelectorAll(
            ".corban-correspondent__list > li"
          ).length;

          const totalFound = result.data[result.data.length - 1].total;

          if (partnerFilter === "solar") {
            if (totalReg < 10) {
              this.btnFindMore.style.visibility = "hidden";
              this.msgResult.style.display = "none";
            } else {
              this.msgResult.style.display = "none";
              this.btnFindMore.style.visibility = "visible";
              this.btnFindMore.textContent = "Carregar mais";
            }
          } else if (totalReg >= totalFound) {
            this.btnFindMore.style.visibility = "hidden";
            this.msgResult.style.display = "none";
          } else {
            this.msgResult.style.display = "none";
            this.btnFindMore.style.visibility = "visible";
            this.btnFindMore.textContent = "Carregar mais";
          }
        } else {
          this.btnFindMore.style.visibility = "hidden";
          this.btnFindMore.textContent = "Carregar mais";
          this.msgResult.style.display = "block";
          this.msgResult.textContent = "Nenhum registro encontrado.";
        }

        this.titleResult.style.display = "block";
        this.loading.style.display = "none";
        this.resultContainer.style.height = "auto";
      })
      .catch((e) => {
        this.loading.style.display = "none";
        this.btnFindMore.style.visibility = "hidden";
        this.btnFindMore.textContent = "Carregar mais";
        this.msgResult.style.display = "block";
        this.msgResult.textContent = "Nenhum registro encontrado.";
        this.resetResult();
        this.clearForm();
      });
  },

  toggleSearchType() {
    const objReplace = {
      nome: "Nome",
      endereco: "Localidade",
      CNPJ: "CNPJ",
    };

    const placeholderText = {
      nome: "Pesquise por Nome ou Razão Social",
      endereco: "Pesquise por Rua, Bairro, Cidade ou Estado",
      CNPJ: "Pesquise por CNPJ",
    };

    const nameMsgWarning = {
      nome: "nome",
      endereco: "endereço",
      CNPJ: "CNPJ",
    };

    const className = "corban-correspondent__form-button--active";
    const input = document.querySelector(".js-corban-correspondent-input");

    document
      .querySelectorAll("button.js-btn-search-type")
      .forEach((element) => {
        element.addEventListener("click", ({ target }) => {
          this.resetResult();
          this.clearForm();

          document
            .querySelectorAll("button.js-btn-search-type")
            .forEach((item) => item.classList.remove(className));

          if (!target.classList.contains(className)) {
            target.classList.add(className);
          }

          this.searchType = target.getAttribute("data-type");
          document.querySelector(
            "span.js-corban-correspondent-label"
          ).textContent = objReplace[this.searchType];
          input.placeholder = placeholderText[this.searchType];
          this.nameControl = nameMsgWarning[this.searchType];

          if (
            this.searchType === "nome" ||
            this.searchType === "endereco" ||
            this.searchType === "CNPJ"
          ) {
            input.classList.add(
              "corban-correspondent__input--show-placeholder"
            );

            if (this.searchType === "CNPJ") {
              this.msgValidationField.style.visibility = "visible";
            } else {
              this.msgValidationField.style.visibility = "hidden";
            }
          } else {
            input.classList.remove(
              "corban-correspondent__input--show-placeholder"
            );
          }
        });
      });
  },

  searchInput() {
    this.formFindCorrespondent.addEventListener("submit", (event) => {
      this.resetResult();
      event.preventDefault();
      const input = this.input;
      if (this.searchType === "CNPJ") {
        this.search = `&${this.searchType}=${input.value
          .normalize("NFD")
          .replace(/\D/g, "")}`;
      } else {
        this.search = `&${this.searchType}=${input.value
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")}`;
      }

      this.renderCorrespondent();
    });

    this.input.addEventListener("input", (e) => {
      let lengthDig = "";

      if (this.searchType === "CNPJ") {
        this.input.addEventListener("keydown", function (event) {
          const key = event.key;
          if (key === "Backspace" || key === "Delete") {
            event.target.value = "";
            return false;
          }
        });

        lengthDig = parseInt(
          document
            .getElementById("txtSearch")
            .value.toString()
            .replace(/\D/g, "").length
        );
      } else {
        lengthDig = document
          .getElementById("txtSearch")
          .value.normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "").length;
      }

      if (this.searchType === "CNPJ") {
        if (lengthDig <= 14) {
          const x = e.target.value
            .replace(/\D/g, "")
            .match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
          e.target.value = !x[2]
            ? x[1]
            : x[1] +
              "." +
              x[2] +
              "." +
              x[3] +
              "/" +
              x[4] +
              (x[5] ? "-" + x[5] : "");

          this.msgValidationField.textContent = "";

          if (this.isValidCNPJ() && lengthDig === 14) {
            this.btnSearch.disabled = false;
            this.msgValidationField.textContent = "";
          } else {
            this.btnSearch.disabled = true;
          }
        } else {
          this.btnSearch.disabled = false;
          document.getElementById("txtSearch").value = document
            .getElementById("txtSearch")
            .value.toString()
            .slice(0, -1);
        }

        return;
      } else {
        if (lengthDig >= 2) {
          this.msgValidationField.style.visibility = "hidden";
          this.msgValidationField.textContent = "";
          this.btnSearch.disabled = false;
        } else {

          this.msgValidationField.textContent =
            "Por favor, forneça um " + this.nameControl + " válido.";
          this.btnSearch.disabled = true;
          this.msgValidationField.style.visibility = "visible";
        }
      }
    });

    document
      .querySelector("button.js-btn-find-more")
      .addEventListener("click", () => {
        this.incrementPage();
        this.renderCorrespondent();
      });

    this.resetForm.addEventListener("click", () => {
      this.resetResult();
      this.clearForm();
    });
  },

  isValidCNPJ() {
    const resultado = document.getElementById("msgValidationField");
    const inputSearch = document.getElementById("txtSearch").value;
    const valorVerifica = inputSearch;

    let cnpj = valorVerifica.replace(/[^\d]+/g, "");

    if (cnpj.length !== 14) {
      resultado.textContent = "Por favor, forneça um CNPJ válido.";
      return false;
    }

    // Calcule os dígitos verificadores
    const digitos = cnpj.split("");
    let sum = 0;
    let factor = 5;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(digitos[i]) * factor;
      factor = factor === 2 ? 9 : factor - 1;
    }
    let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (parseInt(digitos[12]) !== digit) {
      resultado.textContent = "Por favor, forneça um CNPJ válido.";
      return false;
    }

    sum = 0;
    factor = 6;
    for (let i = 0; i < 13; i++) {
      sum += parseInt(digitos[i]) * factor;
      factor = factor === 2 ? 9 : factor - 1;
    }
    digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (parseInt(digitos[13]) !== digit) {
      resultado.textContent = "Por favor, forneça um CNPJ válido.";
      return false;
    }

    // resultado.textContent = "CNPJ válido!";
    resultado.textContent = "";
    return true;
  },

  resetResult() {
    this.btnFindMore.style.visibility = "hidden";
    this.correspondentContainer.innerHTML = "";
    this.numberPage = 0;
    this.btnSearch.disabled = true;
    this.msgValidationField.textContent = "";
    this.msgResult.style.display = "block";
    this.msgResult.textContent =
      "Para encontrar o melhor parceiro, preencha um dos campos de busca.";
  },

  clearForm() {
    this.input.value = "";
    this.formFindCorrespondent.reset();
  },
};

corbanCorrespondent.init();
